<template>
  <div class="ui container segment">
    <div class="ui grid">
      <div class="sixteen wide column">
        <div class="ui items">
          <div class="item">
            <div class="ui small image">
              <img :src="main_image_resource_url()" />
            </div>
            <div class="content">
              <div
                class="ui right floated basic icon labeled button"
                @click="back"
              >
                <i class="left arrow icon"></i>
                {{ $t("back") }}
              </div>
              <a class="header">{{ piece.setup.name }}</a>
              <div class="meta">
                <span>{{ piece.setup.description }}</span>
              </div>
              <div class="description">
                <div class="ui three column grid">
                  <div class="column">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !piece.setup.site }"
                    >
                      <div class="ui basic blue label">
                        <i class="map marker alternate icon"></i>
                        {{ $t("site") }}
                      </div>
                      <div class="ui basic label">{{ piece.setup.site }}</div>
                      <div
                        class="ui basic green label"
                        @click="
                          view_map(
                            piece.setup.site_latitude,
                            piece.setup.site_longitude,
                          )
                        "
                        v-if="
                          piece.setup.site_latitude &&
                            piece.setup.site_longitude
                        "
                      >
                        <i class="map alternate icon"></i>
                        {{ $t("visit") }}
                      </div>
                    </a>
                  </div>
                  <div class="column">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !piece.setup.cultural_area }"
                    >
                      <div class="ui basic blue label">
                        <i class="compass icon"></i>
                        {{ $t("cultural area") }}
                      </div>
                      <div class="ui basic label">
                        {{ piece.setup.cultural_area }}
                      </div>
                    </a>
                  </div>
                  <div class="column">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !piece.setup.cultural_subarea }"
                    >
                      <div class="ui basic blue label">
                        <i class="compass icon"></i>
                        {{ $t("cultural sub-area") }}
                      </div>
                      <div class="ui basic label">
                        {{ piece.setup.cultural_subarea }}
                      </div>
                    </a>
                  </div>
                  <div class="column">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !piece.setup.region }"
                    >
                      <div class="ui basic blue label">
                        <i class="compass icon"></i>
                        {{ $t("region") }}
                      </div>
                      <div class="ui basic label">{{ piece.setup.region }}</div>
                    </a>
                  </div>
                  <div class="column">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !piece.setup.origin }"
                    >
                      <div class="ui basic blue label">
                        <i class="compass icon"></i>
                        {{ $t("origin") }}
                      </div>
                      <div class="ui basic label">{{ piece.setup.origin }}</div>
                    </a>
                  </div>
                  <div class="column">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !piece.setup.temporality }"
                    >
                      <div class="ui basic blue label">
                        <i class="time icon"></i>
                        {{ $t("temporality") }}
                      </div>
                      <div class="ui basic label">
                        {{ piece.setup.temporality }}
                      </div>
                    </a>
                  </div>
                  <div class="column">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !piece.setup.support }"
                    >
                      <div class="ui basic blue label">
                        <i class="university icon"></i>
                        {{ $t("support") }}
                      </div>
                      <div
                        class="ui basic label"
                        v-for="(s, idx) in split(piece.setup.support)"
                        :key="idx"
                      >
                        {{ s }}
                      </div>
                    </a>
                  </div>
                  <div class="column">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !piece.setup.style }"
                    >
                      <div class="ui basic blue label">
                        <i class="mosque icon"></i>
                        {{ $t("style") }}
                      </div>
                      <div class="ui basic label">{{ piece.setup.style }}</div>
                    </a>
                  </div>
                  <!-- <div class="column">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !piece.setup.site }"
                    >
                      <div class="ui basic blue label">
                        <i class="time icon"></i>
                        {{ $t("motive") }}
                      </div>
                      <div
                        class="ui basic label"
                        v-for="(s, idx) in split(piece.setup.motive)"
                        :key="idx"
                      >
                        {{ s }}
                      </div>
                    </a>
                  </div>-->
                </div>
                <!-- <div class="ui divided selection list">
                  <a class="item" v-bind:class="{ hidden: !piece.setup.site }">
                    <div class="ui basic blue label">
                      <i class="map marker alternate icon"></i>
                      {{ $t("site") }}
                    </div>
                    <div class="ui basic label">{{ piece.setup.site }}</div>
                  </a>
                  <a
                    class="item"
                    v-bind:class="{ hidden: !piece.setup.deposit }"
                  >
                    <div class="ui basic blue label">
                      <i class="gopuram icon"></i>
                      {{ $t("deposit") }}
                    </div>
                    <div class="ui basic label">{{ piece.setup.deposit }}</div>
                  </a>
                  <a
                    class="item"
                    v-bind:class="{ hidden: !piece.setup.cultural_area }"
                  >
                    <div class="ui basic blue label">
                      <i class="compass icon"></i>
                      {{ $t("cultural area") }}
                    </div>
                    <div class="ui basic label">
                      {{ piece.setup.cultural_area }}
                    </div>
                  </a>
                  <a
                    class="item"
                    v-bind:class="{ hidden: !piece.setup.temporality }"
                  >
                    <div class="ui basic blue label">
                      <i class="time icon"></i>
                      {{ $t("temporality") }}
                    </div>
                    <div class="ui basic label">
                      {{ piece.setup.temporality }}
                    </div>
                  </a>
                  <a class="item" v-bind:class="{ hidden: !piece.setup.style }">
                    <div class="ui basic blue label">
                      <i class="mosque icon"></i>
                      {{ $t("style") }}
                    </div>
                    <div class="ui basic label">
                      {{ piece.setup.style }}
                    </div>
                  </a>
                  <a
                    class="item"
                    v-bind:class="{ hidden: !piece.setup.support }"
                  >
                    <div class="ui basic blue label">
                      <i class="university icon"></i>
                      {{ $t("support") }}
                    </div>
                    <div
                      class="ui basic label"
                      v-for="(s, idx) in split(piece.setup.support)"
                      :key="idx"
                    >
                      {{ s }}
                    </div>
                  </a>
                  <a class="item" v-bind:class="{ hidden: !piece.setup.site }">
                    <div class="ui basic blue label">
                      <i class="time icon"></i>
                      {{ $t("motive") }}
                    </div>
                    <div
                      class="ui basic label"
                      v-for="(s, idx) in split(piece.setup.motive)"
                      :key="idx"
                    >
                      {{ s }}
                    </div>
                  </a>
                </div>-->
              </div>
              <h4 class="ui dividing header">{{ $t("attributes") }}</h4>
              <div class="extra">
                <div class="ui divided selection list">
                  <a
                    class="item"
                    v-bind:class="{ hidden: !attribute.value }"
                    v-for="(attribute, index) in piece.setup.attributes"
                    v-bind:key="index"
                  >
                    <div class="ui basic label">{{ attribute.name }}</div>
                    <!-- <div class="ui basic label">{{ attribute.value }}</div> -->
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ui two column divided grid">
      <div class="row">
        <div class="column">
          <div
            class="ui icon message"
            v-if="piece.setup.sources && piece.setup.sources.length > 0"
          >
            <i class="asterisk icon"></i>
            <div class="content">
              <div class="header">{{ $t("zotero references") }}</div>
              <ul class="list">
                <li v-for="(r, idx) in piece.setup.sources" :key="idx">
                  <a class="item" :href="r" target="_blank">{{ r }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="column">
          <div
            class="ui icon message"
            v-if="piece.setup.animals && piece.setup.animals.length > 0"
          >
            <i class="cat icon"></i>
            <div class="content">
              <div class="header">{{ $t("animals") }}</div>
              <ul class="list">
                <li v-for="(r, idx) in piece.setup.animals" :key="idx">
                  {{ r }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <div
            class="ui icon message"
            v-if="piece.setup.plants && piece.setup.plants.length > 0"
          >
            <i class="pagelines icon"></i>
            <div class="content">
              <div class="header">{{ $t("plants") }}</div>
              <ul class="list">
                <li v-for="(r, idx) in piece.setup.plants" :key="idx">
                  {{ r }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="column">
          <div
            class="ui icon message"
            v-if="piece.setup.landscapes && piece.setup.landscapes.length > 0"
          >
            <i class="image icon"></i>
            <div class="content">
              <div class="header">{{ $t("landscapes") }}</div>
              <ul class="list">
                <li v-for="(r, idx) in piece.setup.landscapes" :key="idx">
                  {{ r }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <div
            class="ui icon message"
            v-if="piece.setup.objects && piece.setup.objects.length > 0"
          >
            <i class="cookie icon"></i>
            <div class="content">
              <div class="header">{{ $t("objects") }}</div>
              <ul class="list">
                <li v-for="(r, idx) in piece.setup.objects" :key="idx">
                  {{ r }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="column">
          <div
            class="ui icon message"
            v-if="piece.setup.characters && piece.setup.characters.length > 0"
          >
            <i class="meh icon"></i>
            <div class="content">
              <div class="header">{{ $t("characters") }}</div>
              <ul class="list">
                <li v-for="(r, idx) in piece.setup.characters" :key="idx">
                  {{ r }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="column">
        <div
          class="ui icon message"
          v-if="
            piece.setup.zoomorphic_characters &&
              piece.setup.zoomorphic_characters.length > 0
          "
        >
          <i class="dragon icon"></i>
          <div class="content">
            <div class="header">
              {{ $t("zoomorphic characters") }}
            </div>
            <ul class="list">
              <li
                v-for="(r, idx) in piece.setup.zoomorphic_characters"
                :key="idx"
              >
                {{ r }}
              </li>
            </ul>
          </div>
        </div>
      </div>-->
    </div>

    <h4 class="ui dividing header">{{ $t("image gallery") }}</h4>
    <div class="ui four cards">
      <div class="card" v-for="(img, idx) in piece.setup.images" :key="idx">
        <div class="image">
          <img v-img:name class="ui image" :src="resource_url(img)" />
        </div>
        <div class="ui bottom attached basic buttons">
          <div
            :data-tooltip="$t('download')"
            class="ui button"
            @click.stop="download(img)"
          >
            <i class="ui download icon"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{ piece.setup }} </pre> -->
  </div>
</template>

<script>
import filters from "@/filters";
import { local_api, error_toast, api_host } from "@/utils";

// @ is an aliass to /src
export default {
  name: "ArcheologyPieceView",
  components: {},
  filters: filters,
  data() {
    return {
      piece: { setup: {} },
    };
  },
  methods: {
    main_image_resource_url() {
      if (!this.piece.setup.images || this.piece.setup.images.length == 0)
        return `/images/icons/archeology.jpg`;
      else {
        let file_name = this.piece.setup.images[0].server_file;
        return `${api_host}/public/uploads/archeology/${file_name}`;
      }
    },
    resource_url(image) {
      return `${api_host}/public/uploads/archeology/${image.server_file}`;
    },
    download(image) {
      this.$http({
        method: "get",
        url: `${api_host}/public/uploads/archeology/${image.server_file}`,
        responseType: "arraybuffer",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", image.filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => console.log("error occured"));
    },
    split(text) {
      if (text) {
        let splitted = text.split(",");
        return splitted;
      }
    },
    view_map(latitude, longitude) {
      window.open(
        `https://www.google.com/maps/place/${latitude},${longitude}`,
        "_blank",
      );
      // console.log(latitude, longitude);
    },
    back() {
      this.$router.go(-1);
    },
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/archeology/do-get-piece", {
      u: this.$route.query.u,
    })
      .then((r) => {
        vm.piece = r;
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  mounted() {},
  watch: {},
};
</script>

<style>
.three.column.grid .column {
  margin-bottom: 0;
  padding-bottom: 0;
}
</style>
